import React from 'react';
import '../../public/css/media/_restricted-tooltip.scss';

function RestrictedComponent() {
  return (
    <div className="tool-tip" >
      <div>
        <i
          className="fa fa-exclamation-circle"
          style={{ marginRight: '5px', color: '#feab10' }}/>
          Suspended Delivery Location
        </div>
      <div style={{width: '30%'}}>
        <a href="/covid19-response" target="blank" style={{color: '#000'}}>See full list
        <i className="fa fa-chevron-right" style={{ marginLeft: '5px' }}/></a>
      </div>
    </div> 
  )
}

export default RestrictedComponent;


/** WEBPACK FOOTER **
 ** ./src/components/RestrictedTooltip.js
 **/